import React from 'react';
import { Badge } from 'primereact/badge';
import { Card } from 'primereact/card';
import { ShippingLineItem } from '../../../DeShippingTableWrapper';
import { LineItemStatusBadge } from '../../LineItemStatusBadge';
import { LineItemFulfillmentLocationTemplate } from '../../shared/LineItemFulfillmentLocationTemplate';
import { useLineItemImages } from '../../../hooks/useLineItemImages';

interface LineItemCardProps {
  lineItemImagesHook: ReturnType<typeof useLineItemImages>;
  item: ShippingLineItem;
  isSelected: boolean;
  isLastItem: boolean;
}

export const LineItemCard: React.FC<LineItemCardProps> = ({
  lineItemImagesHook,
  item,
  isSelected,
  isLastItem,
}) => {
  // Card footer content - just status
  const cardFooter = (
    <div className="flex align-items-center gap-6">
      <LineItemStatusBadge status={item.fulfillment_status || 'unassigned'} />
      <LineItemFulfillmentLocationTemplate {...item} />
    </div>
  );

  // Dynamic card styling based on state
  const cardStyle = {
    border: isSelected ? '2px solid #007bff' : '1px solid #dee2e6',
    borderRadius: '6px',
    marginBottom: isLastItem ? '0' : '16px',
    boxShadow: isSelected ? '0 4px 8px rgba(0, 123, 255, 0.15)' : 'none',
    cursor: 'pointer'
  };

  return (
    <Card
      title={`Product: ${item.product_sku}`}
      subTitle={item.product_name}
      footer={cardFooter}
      style={cardStyle}
      className="hover:shadow-md"
    >
      {/* Decline reason if applicable */}
      {item.fulfillment_status === 'declined' && item.decline_reason && (
        <div className="flex align-items-center gap-2 p-2 bg-orange-50 border-1 border-orange-200 border-round-md">
          <i className="pi pi-info-circle text-orange-500 text-sm" />
          <span className="text-orange-700 text-xs">
            Decline reason: {item.decline_reason}
          </span>
        </div>
      )}
    </Card>
  );
};